'use client'

import React from 'react'
import type { Locale } from '@/i18n'
import { cn } from '@/utilities/ui'
import { useApplicationModalStore } from '@/stores/applicationModalStore'

interface SingleCTAProps {
  locale: Locale
  className?: string
}

export function SingleCTA({ locale, className }: SingleCTAProps) {
  const { openModal } = useApplicationModalStore()

  const t = {
    uk: { join: 'Приєднатися' },
    en: { join: 'Apply Now' },
  }[locale]

  return (
    <>
      {/* Mobile Sticky CTA */}
      <div
        className={cn(
          'fixed bottom-0 left-0 right-0 md:hidden z-[100]',
          'bg-background border-t border-border p-4',
          className,
        )}
      >
        <button
          onClick={() => openModal()}
          className="inline-flex items-center justify-center px-6 py-3 bg-primary text-white rounded-full md:rounded-lg hover:bg-primary/90 transition-colors text-lg font-medium w-full"
        >
          {t.join}
        </button>
      </div>
      {/* Spacer to prevent content from being hidden behind sticky CTA */}
      <div className="md:hidden h-20" />
    </>
  )
}
